import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import {
  PURCHASE_ROUTE,
  PRODUCT_DETAIL_MOBILE_ROUTE,
  PRODUCT_DETAIL_TRACKING_MOBILE_ROUTE,
  REPORT_ISSUES,
  AUTHORIZE_THIRD,
  CHANGE_DISPATCH_ADDRESS,
  SILVER_GOLD_PAYMENT,
  BAD_STATE,
  ARRIVED_INCOMPLETE,
  NOT_WORKING,
  PRODUCT_CHANGE,
  ANOTHER_PRODUCT,
  ASSEMBLE_PRODUCT,
  ALARM_IN_PRODUCT,
  CANCEL_PURCHASE,
  CANCELLATION_PURCHASE_STATUS,
  NOT_RECEIVED,
} from '../../../constants/Routes';

import MyPurchases from './MyPurchases';
import ProductMobileDetailView from './components/mobile/detail-view/ProductMobileDetailView';
import TrackingMobileView from './components/mobile/tracking-view/TrackingMobileView';
import ReportIssue from './components/report-issue-view/ReportIssue';
import FormsViews from './components/report-issue-view/mobile/forms-views/FormsViews';
import {
  getProducts,
  setSelectedProduct,
} from '../../../redux/actions/ProductActions';
import { getImage } from '../../../redux/actions/ImageActions';
import useQuery from '../../../hooks/useQuery/useQuery';
import usePathname from '../../../hooks/usePathname/usePathname';

const PurchasesRoutes = ({ ...props }) => {
  const { mobile } = props;
  const query = useQuery();
  const history = useHistory();
  const dispatch = useDispatch();
  const pathname = usePathname();
  const { products, selectedProduct: product } = useSelector(
    (state) => state.productReducer,
  );

  const pathsWithProduct = [
    REPORT_ISSUES,
    AUTHORIZE_THIRD,
    CHANGE_DISPATCH_ADDRESS,
    SILVER_GOLD_PAYMENT,
    BAD_STATE,
    ANOTHER_PRODUCT,
    PRODUCT_CHANGE,
  ];

  const isCurrentPathWithProduct = () => pathsWithProduct.includes(pathname);

  const validateSelectedProduct = (filteredProducts) => {
    if (filteredProducts.length) {
      const [selectedProduct] = filteredProducts;
      dispatch(getImage(selectedProduct.sku));
      dispatch(setSelectedProduct(selectedProduct));
    } else {
      history.push(PURCHASE_ROUTE);
    }
  };

  useEffect(() => {
    if (isCurrentPathWithProduct() && !products.length && !product?.orderId) {
      dispatch(getProducts());
    }
  }, [product]);

  useEffect(() => {
    if (isCurrentPathWithProduct() && products.length && !product?.orderId) {
      const queryOrderId = query.get('orderId');
      const querySku = query.get('sku');

      const filteredProducts = products.filter(
        (prod) =>
          prod.orderId.toString() === queryOrderId && prod.sku === querySku,
      );

      validateSelectedProduct(filteredProducts);
    }
  }, [products]);

  return (
    <Switch>
      <Route exact path={PURCHASE_ROUTE}>
        <MyPurchases path={PURCHASE_ROUTE} mobile={mobile} />
      </Route>
      <Route exact path={PRODUCT_DETAIL_MOBILE_ROUTE}>
        <ProductMobileDetailView />
      </Route>
      <Route exact path={PRODUCT_DETAIL_TRACKING_MOBILE_ROUTE}>
        <TrackingMobileView mobile={mobile} />
      </Route>
      <Route exact path={REPORT_ISSUES}>
        <ReportIssue mobile={mobile} product={product} />
      </Route>
      <Route exact path={AUTHORIZE_THIRD}>
        <FormsViews product={product} />
      </Route>
      <Route exact path={CHANGE_DISPATCH_ADDRESS}>
        <FormsViews product={product} />
      </Route>
      <Route exact path={SILVER_GOLD_PAYMENT}>
        <FormsViews product={product} />
      </Route>
      <Route exact path={BAD_STATE}>
        <FormsViews product={product} />
      </Route>
      <Route exact path={ARRIVED_INCOMPLETE}>
        <FormsViews />
      </Route>
      <Route exact path={NOT_WORKING}>
        <FormsViews />
      </Route>
      <Route exact path={PRODUCT_CHANGE}>
        <FormsViews product={product} />
      </Route>
      <Route exact path={ANOTHER_PRODUCT}>
        <FormsViews product={product} />
      </Route>
      <Route exact path={ASSEMBLE_PRODUCT}>
        <FormsViews product={product} />
      </Route>
      <Route exact path={ALARM_IN_PRODUCT}>
        <FormsViews product={product} />
      </Route>
      <Route exact path={CANCEL_PURCHASE}>
        <FormsViews product={product} />
      </Route>
      <Route exact path={CANCELLATION_PURCHASE_STATUS}>
        <FormsViews product={product} />
      </Route>
      <Route exact path={NOT_RECEIVED}>
        <FormsViews product={product} />
      </Route>
    </Switch>
  );
};

PurchasesRoutes.propTypes = {
  mobile: PropTypes.bool,
};

export default PurchasesRoutes;
